"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = require("moment");

exports.default = {
  props: ["occasion", "employee"],

  data: function data() {
    return {
      isOccasionHasPassed: false,
      filledHealthdeclarations: false,
      healthdeclarationTests: [],
      occasionHasActualTime: false,
      bookedTime: null,
      employeeIsInOccasion: false,
      pdfResults: [],
      sentEmail: null,
      sentSMS: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var userProjects = this.employee.projects.map(function (_ref) {
      var id = _ref.id;
      return id;
    });
    this.employeeIsInOccasion = this.employee.occasions.filter(function (occasion) {
      return occasion.id === _this.occasion.id && userProjects.includes(occasion.project_id);
    }).length;
  },
  created: function created() {
    var _this2 = this;

    this.isOccasionHasPassed = moment(this.occasion.end_date).endOf("day").isBefore(moment());

    this.filledHealthdeclarations = this.employee.dashboard_tests.filter(function (test) {
      return test.occasion_id === _this2.occasion.id && test.related_type && test.related_type.template_type === "questionnaire";
    });

    this.healthdeclarationTests = this.occasion.test_types ? this.occasion.test_types.filter(function (_ref2) {
      var template_type = _ref2.template_type;
      return template_type === "questionnaire";
    }) : [];

    this.occasionHasActualTime = !this.occasion.free_times ? false : !!this.occasion.free_times.filter(function (time) {
      return moment(time.time).isAfter(moment());
    }).length;

    this.bookedTime = !this.employee || !this.employee.times ? null : this.employee.times.find(function (time) {
      return time.user_id === _this2.employee.id && time.occasion_id === _this2.occasion.id;
    });

    this.pdfResults = this.occasion.pdf_results || [];
    //this.loadLastMessage();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/occasions/Occasion.vue
// module id = G/13
// module chunks = 1